export default "__VITE_ASSET__J9J$AvLm__"